import { apiFetch } from './apiClient';

/* Rotinas programadas (menu Rotinas) e a aba Vencimentos do Painel --
   backend /rotinas-programadas. Um bloco = recorrência + período (só os
   dias quando repete) + local opcional + rotinas (nome + dia dentro do
   período) + clientes. Cada mês ele gera as ocorrências com mês/ano. */
const B = '/rotinas-programadas';

export const listarBlocosRotina = () => apiFetch(`${B}/blocos`);
export const criarBlocoRotina = (d) => apiFetch(`${B}/blocos`, { method: 'POST', body: JSON.stringify(d) });
export const atualizarBlocoRotina = (id, d) => apiFetch(`${B}/blocos/${id}`, { method: 'PUT', body: JSON.stringify(d) });
export const excluirBlocoRotina = (id) => apiFetch(`${B}/blocos/${id}`, { method: 'DELETE' });

/* modo 'competencia': o mês é a competência das informações, não o do vencimento */
export const buscarVencimentosRotinas = (competencia, modo) =>
  apiFetch(`${B}/vencimentos?competencia=${competencia}${modo === 'competencia' ? '&modo=competencia' : ''}`);
/* conclusão é por ocorrência: rotina x cliente x data */
export const marcarRotina = (itemId, clienteId, data, concluido, motivo, extra = {}) =>
  apiFetch(`${B}/execucoes`, { method: 'PUT', body: JSON.stringify({ item_id: itemId, cliente_id: clienteId, data, concluido, motivo, ...extra }) });
/* observação da ocorrência (só daquele mês); texto vazio apaga */
export const salvarObservacao = (itemId, clienteId, data, texto) =>
  apiFetch(`${B}/observacoes`, { method: 'PUT', body: JSON.stringify({ item_id: itemId, cliente_id: clienteId, data, texto }) });
/* "sem movimento" da ocorrência: sem declaração já baixa; com declaração fica pendente */
export const marcarSemMovimento = (itemId, clienteId, data, precisaDeclaracao, extra = {}) =>
  apiFetch(`${B}/sem-movimento`, { method: 'PUT', body: JSON.stringify({ item_id: itemId, cliente_id: clienteId, data, precisa_declaracao: precisaDeclaracao, ...extra }) });
export const desmarcarSemMovimento = (itemId, clienteId, data) =>
  apiFetch(`${B}/sem-movimento?item_id=${itemId}&cliente_id=${clienteId}&data=${data}`, { method: 'DELETE' });
/* histórico da bolinha (quem concluiu/reabriu, quando, motivo) -- só gerente e administrador */
export const buscarHistoricoRotina = (itemId, clienteId, data) =>
  apiFetch(`${B}/historico?item_id=${itemId}&cliente_id=${clienteId}&data=${data}`);

export const RECORRENCIAS = [
  { v: 'mensal', l: 'Mensal' }, { v: 'semanal', l: 'Semanal' }, { v: 'trimestral', l: 'Trimestral' },
  { v: 'semestral', l: 'Semestral' }, { v: 'anual', l: 'Anual' }, { v: 'unica', l: 'Não repete (data única)' },
];
export const DIAS_SEMANA = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom']; // 1..7
export const MESES = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
const PASSO = { trimestral: 3, semestral: 6, anual: 12 };

/* "05/10" ou "01/10 – 20/10" (mesmo dia mostra uma data só) */
export function textoPeriodo(inicio, fim) {
  const f = (iso) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;
  return inicio === fim ? f(inicio) : `${f(inicio)} – ${f(fim)}`;
}

const doisDig = (n) => String(n).padStart(2, '0');

/* resumo do bloco pra lista: "Mensal · dias 01 a 20", "Trimestral (jan, abr, jul, out) · dias 01 a 20" */
export function textoRecorrencia(b) {
  if (b.recorrencia === 'unica') {
    return b.inicio ? `Não repete · ${textoPeriodo(b.inicio, b.fim)}/${b.inicio.slice(0, 4)}` : 'Não repete';
  }
  if (b.recorrencia === 'semanal') {
    const s = DIAS_SEMANA[b.semana_inicio - 1], e = DIAS_SEMANA[b.semana_fim - 1];
    return `Semanal · ${s === e ? s.toLowerCase() : `${s.toLowerCase()} a ${e.toLowerCase()}`}`;
  }
  const dias = b.dia_inicio === b.dia_fim ? `dia ${doisDig(b.dia_inicio)}` : `dias ${doisDig(b.dia_inicio)} a ${doisDig(b.dia_fim)}`;
  if (b.recorrencia === 'mensal') return `Mensal · ${dias}`;
  const passo = PASSO[b.recorrencia];
  const meses = Array.from({ length: 12 / passo }, (_, i) => MESES[(b.mes_referencia - 1 + i * passo) % 12].toLowerCase());
  const nome = { trimestral: 'Trimestral', semestral: 'Semestral', anual: 'Anual' }[b.recorrencia];
  return `${nome} (${meses.join(', ')}) · ${dias}`;
}

/* dia da rotina como texto curto pra lista */
export function textoDiaRotina(b, it) {
  if (b.recorrencia === 'unica') return it.data ? `${it.data.slice(8, 10)}/${it.data.slice(5, 7)}` : 'até o fim';
  if (!it.dia) return 'até o fim';
  if (b.recorrencia === 'semanal') return DIAS_SEMANA[it.dia - 1]?.toLowerCase() || '';
  return `dia ${doisDig(it.dia)}`;
}

/* pacotes: agrupam rotinas (blocos) e clientes -- quem está no pacote
   tem todas as rotinas dele */
export const listarPacotesRotina = () => apiFetch(`${B}/pacotes`);
export const criarPacoteRotina = (d) => apiFetch(`${B}/pacotes`, { method: 'POST', body: JSON.stringify(d) });
export const atualizarPacoteRotina = (id, d) => apiFetch(`${B}/pacotes/${id}`, { method: 'PUT', body: JSON.stringify(d) });
export const excluirPacoteRotina = (id) => apiFetch(`${B}/pacotes/${id}`, { method: 'DELETE' });

/* particularidade da etapa pra um cliente (a "orelha" em Vencimentos);
   texto vazio apaga */
/* vale do mês `vigencia` ('YYYY-MM') em diante; os anteriores não mudam */
export const salvarParticularidade = (itemId, clienteId, vigencia, texto) =>
  apiFetch(`${B}/particularidades`, { method: 'PUT', body: JSON.stringify({ item_id: itemId, cliente_id: clienteId, vigencia, texto }) });

/* setores das etapas -- os mesmos das anotações por cliente */
export const SETORES_ROTINA = [
  { v: 'fiscal', l: 'Fiscal' }, { v: 'folha', l: 'Folha' },
  { v: 'contabil', l: 'Contábil' }, { v: 'conformidade', l: 'Conformidade' },
];
export const rotuloSetor = (v) => SETORES_ROTINA.find(x => x.v === v)?.l || v;
